module.exports = __webpack_public_path__ + "static/media/airlineflight.d45c80b6.png";